import { Select } from "chakra-react-select";
import { useEffect, useState } from "react";
import { Favorites } from "../../../../interfaces/defaultInterfaces";
import FavoritesAPi from "../../../../services/favoritesApi";

interface SelectFavoriteProps {
  cliente: number;
  setFavorite: (favorite: Favorites) => void;
}

export default function SelectFavorite({ cliente, setFavorite }: SelectFavoriteProps) {
  const [favoriteList, setFavoriteList] = useState<Favorites[]>([]);
  const [value, setValue] = useState<number | null>(null);
  const [search, setSearch] = useState<string>("");

  async function getfavoriteList() {
    if (cliente !== 0) {
      try {
        const response = await FavoritesAPi.getFavorecidosList(1, 50, cliente, search);
        setFavoriteList(response.data);
      } catch (error) {
        console.log("error", error);
      }
    }
  }

  useEffect(() => {
    getfavoriteList();
  }, [cliente, search]);

  const clientOptions = favoriteList.map((client) => ({
    key: client.id,
    value: client.id,
    label: client.nomeTitular,
  }));

  function onChangeClientFilter(e: any) {
    setValue(Number(e.value));
    const favorecido = favoriteList.find(
      (item: Favorites) => item.id === Number(e.value)
    );
    if (favorecido) {
      setFavorite(favorecido);
    }
  }

  return (
    <>
      <Select
        focusBorderColor="blue.500"
        name="colors"
        options={clientOptions}
        placeholder="Selecionar Favorecidos"
        closeMenuOnSelect={true}
        size="md"
        isSearchable={true} // Ativar pesquisa
        onChange={onChangeClientFilter}
        onInputChange={(e: string) => setSearch(e)} // Permitir digitação livre
      />
    </>
  );
}
